// EtkinlikKitapScreen.js - İnteraktif Kitap Görünümü
// Kanıt Temelli Tarih: Yerleşme ve Devletleşme Sürecinde Selçuklu Türkiyesi

import { BottomNav } from '../common/BottomNav.js';

// ===== BECERİ ETİKETLERİ =====
const SKILL_MAP = {
    'Tarihsel Empati Becerisi': { cls: 'empati', icon: '❤️' },
    'Zamanı Algılama ve Kronolojik Düşünme Becerisi': { cls: 'zaman', icon: '⏳' },
    'Değişim ve Sürekliliği Algılama Becerisi': { cls: 'degisim', icon: '🔄' },
    'Kanıta Dayalı Sorgulama ve Araştırma Becerisi': { cls: 'kanit', icon: '🔍' },
    'Tarihsel Sorun Analizi ve Karar Verme Becerisi': { cls: 'sorun', icon: '⚖️' }
};

function skillTag(name) {
    const s = SKILL_MAP[name] || { cls: 'empati', icon: '📌' };
    return '<span class="beceri-tag ' + s.cls + '">' + s.icon + ' ' + name + '</span>';
}

// ===== SAYFA VERİLERİ =====
const PAGES = [
    // ---- SAYFA 0: GİRİŞ ----
    {
        type: 'intro'
    },
    // ---- SAYFA 1: KANIT 1 ----
    {
        type: 'evidence',
        num: 1,
        title: 'Kanıt 1: Reşîdüddîn / Câmi\'ut-Tevârîh',
        text: 'Bu İslam fethi 463 (Malazgirt Zaferi) senesi Rebl\'ü\'l-evvelinde (Aralık 1070- Ocak 1071) olmuş idi... Sultan, "Beyleri\'nın memalik-i Rum (Anadolu memleketleri) içlerine ilerlemelerini, fethedip ele geçirebildikleri her mülkün; kendilerinin, evlad ve ahfadına (torunlarına) ait olacağını ve ondan başka hiç kimsenin o (mülk/toprak) üzerinde dahi ve tasarrufunun olmayacağını" buyurdu. (Bunun üzerine) Emir Saltuk Erzenu\'r-Rum (Erzurum) ve çevresini tamamen ele geçirdi. Emir Artuk Mardin, Amid (Diyarbakır), Mencigerd/Malazgirt, Malatya, Harpurt ve bugüne kadar halen ellerinde bulunan yerleri; Danişmend Kayseriyye, Zamandu (Zamantı), Sivas, Develü, Tokat, Nikisar (Niksar), Amasya\'yı; Emir Çavuldur Maraş ve Sarus\'u (Sarız); Emir Mengücik Gazi, Erzincan memaliki (memleketler), Kemah, Kögonya (Şebinkarahisar) ve diğer vilayetleri ele geçirdi... Onlar buralara (Anadolu) yerleşip hakimiyetlerini artırdıkça daha fazla (ülke ve arazi) elde ettiler. Her sene güzel bir yaylada yaylayıp (yaylak) mutlu zamanlar geçirdiler. Zamanla aralarında ihtilaf çıktı. Büyüklük ve kibir sebebiyle münazaa meydana geldi. Sultan Melikşah zamanında Vezir Nizamü\'lmülk\'ün tensibiyle (onayı ile) Süleyman\'ı (Türkiye Selçuklu Devleti kurucusu, Süleymanşah) mülk-i Rum (Anadolu) idaresine gönderdiler ki ümera (Beyler) arasındaki muhalefeti ortadan kaldırsın ve memalik-i padişahta (memleketlerde) bir iklim artsın.',
        source: 'Reşîdüddîn Fazlullah-ı Hemedânî, Câmi\'ut-Tevârîh (Zikr-i Tarih-i Al-i Selçuk), Erkan Göksu, Hüseyin Güneş (Çev.) Bilge Kültür Sanat Yayınları, İstanbul 2010, s.84',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Tarihsel Empati Becerisi'],
        questions: [
            { no: 1, text: 'Kanıt 1\'e göre Anadolu\'ya gelen beyler öncelikle nerelere yerleşmiştir?' },
            { no: 2, text: 'Kanıt 1\'e göre beylerin Anadolu\'da güçlenip aralarında kavga etmeye başlaması, daha sonra hangi önemli siyasi gelişmeye yol açmıştır?' },
            { no: 3, text: 'Kendinizi Kanıt 1\'deki beylerden biri olarak düşünün. Sultan\'ın "Fethettiğiniz toprak tamamen sizin ve çocuklarınızın olacak" sözü size ne hissettirirdi? Motivasyonunuz nasıl etkilenirdi?' }
        ]
    },
    // ---- SAYFA 2: KANIT 2 ----
    {
        type: 'evidence',
        num: 2,
        title: 'Kanıt 2: Çağdaş Bir Ermeni Yazar, Urfalı Mathieu',
        text: '1080 yılı Martına doğru Okyanus denizi berisinde (Anadolu\'da) bulunan bütün Hıristiyan memleketleri Türklerin istilâsına uğramış ve hiçbir vilâyet bundan kurtulamamıştı... Birçok vilâyetler boşaldı; artık Şark (doğu) milleti mevcut değildir... Tarsus\'a, Maraş\'a ve Delûk\'a (Halep yakınında) kadar civar bölgelerde kargaşalıklar hüküm sürüyordu. Zira bu havalide halk kitleler halinde birbiri üzerine atılıyor; binlerce insan birbirinin yolunu tıkıyor; çekirgeler gibi yeryüzünü kaplıyor ve her taraf insan dalgaları ile doluyordu…',
        source: 'Osman TURAN, Selçuklular Tarihi Ve Türk-İslam Medeniyeti, Ötüken Yayınları, İstanbul 2008, s.279',
        skills: ['Tarihsel Empati Becerisi'],
        questions: [
            { no: 4, text: 'Kanıt 2\'de Türklerin akını için kullanılan "çekirgeler gibi" ifadesi o dönemki Hıristiyan halkın yaşadığı duyguları nasıl betimlemektedir?' }
        ]
    },
    // ---- SAYFA 3: KANIT 3 ----
    {
        type: 'evidence',
        num: 3,
        title: 'Kanıt 3: Süryani Tarihçi Mihael (1126-1199) Anlatıyor',
        text: '"Türklere yenilen Rumlar bir daha onlara karşı duramadılar. İmparator Mihael\'i korku aldı. Korkak ve kadınlaşmış müşavirlerinin sözlerine bakarak sarayından ayrılıp Türklere karşı çıkmadı. Hıristiyanlara acıyarak adamlar gönderdi ve Pont\'(Anadolu\'nun orta kısmı)da kalmış halkın bakiyelerini, eşyalarını atlara ve arabalara yükletip denizin ötesine (Balkanlara) nakletti. Böylece ahâlisiz kalan bu bölgelerde Türklerin yerleşmesine yardım etti ve bu sebeple de o, herkesin tenkidine (eleştirisine) uğradı".',
        source: 'Osman TURAN, Selçuklular Tarihi Ve Türk-İslam Medeniyeti, Ötüken Yayınları, İstanbul 2008, s.278',
        skills: ['Tarihsel Empati Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 5, text: 'Kanıt 3\'te İmparator Mihael\'in Rumları Balkanlara yönlendirmesi Türklere nasıl bir avantaj sağlamıştır?' },
            { no: 6, text: 'Kanıt 3\'te "Hıristiyanlara acıyarak adamlar gönderdi" sözü o dönemki Hıristiyan halkın durumu hakkında bize nasıl bir bilgi vermektedir?' }
        ]
    },
    // ---- SAYFA 4: KANIT 4 ----
    {
        type: 'evidence',
        num: 4,
        title: 'Kanıt 4: Bizanslı Tarihçi Ioannes Zonaras',
        text: 'İşler böyle giderken, [1078 yılında] Anadolu\'nun ileri gelenlerinden en namlı olanlar, hep birlikte ayaklanmaya karar verdiler, hükümdar olmak üzere Kouropalates [ünvanlı] Nikephoros Botaneiates\'i seçtiler ve onu imparator ilan ettiler. Bu olay, imparatoru [Mikhael\'i] dehşete düşürdü, çünkü biliyordu ki, bir zaman gelecek, N harfi M harfine üstün gelecekti [bir falcı öyle demişti]... Bunun üzerine imparator Türklerle [Anadolu\'da bulunan ama henüz İznik\'i ele geçirmiş olmayan Kutalmış oğlu Süleymanşah ile] anlaşmaya vardı, eğer asiyi yakalarlar ve kendisinin ellerine teslim ederlerse onlara bol bol armağan vermeyi vadetti.',
        source: 'İoannes Zonaras, Tarihlerin Özeti, Bilge Umar (çev.), Arkeoloji ve Sanat yay., İstanbul 2010, s.148',
        skills: ['Değişim ve Sürekliliği Algılama Becerisi', 'Kanıta Dayalı Sorgulama ve Araştırma Becerisi'],
        questions: [
            { no: 7, text: 'Kanıt 4\'e göre İznik\'in Türkler tarafından alınmasının kaynaklarda geçmemesinin sebebi nedir?' },
            { no: 8, text: 'Kanıt 4\'e göre Bizans\'ın hanedan içi kavgalarla yıpranması ile Süleymanşah\'ın İznik\'i fethedip Marmara\'ya kadar hızla ilerlemesi arasında nasıl bir neden sonuç ilişkisi vardır?' }
        ]
    },
    // ---- SAYFA 5: KANIT 5 ----
    {
        type: 'evidence',
        num: 5,
        title: 'Kanıt 5: Bizanslı Tarihçi Ioannes Zonaras Bryennios\'un İsyanını Anlatıyor (1074-1130)',
        text: '...Botaneiates (Süleymanşah\'ın yardımıyla imparator olan kişi) çeşitli uluslardan ordu devşirmekteydi; bunların arasında Türkler de vardı ve onlarının arasında Pers soylusu [Kutalmış; daha doğrusu, onun oğlu Süleymanşah] seçkinlik gösteriyordu; bu kişi, Sultanın hısımı olduğu halde, bu kişiden [Sultandan] erki kendi hakkı olduğu iddiasıyla istemekteydi ve her ikisi şimdiden savaş için hazırlanmaktaydı... Sultan, ülkesini bölünmemiş olarak muhafaza edecek, ama düşmanının Rum ülkesinden bir bölümünü işgal etmesi ve orada egemenlik sürmesi için her biçimde ona yardımcı olacaktı. Böylece, ikisi anlaşmaya vardılar; bunun üzerine Kutalmış sırada Botaneiates\'in yanında [onu desteklemek üzere] çarpışır durumda olarak, bulunmaktaydı. Bu durumda, Botaneiates, yanında savaş gücü yüksek bir ordu [Süleymanşah\'ın, onun yanına kattığı kalabalık sayıda atlı Türk] ile Nikaia/İznik\'i zapt etmek üzere, seğirtti... Alexios (bir komutan daha sonra imparator oldu) onunla [Bryennios ile], [Silivri doğu yakınında] çok sayıda ve zengin kaynaklarla sulandığı için Kalabrye [iyi kaynaklı, iyice bol kaynaklı] denen yerde çarpıştı. Orada onun ordusunu [Süleymanşah\'ın yardıma gönderdiği 2000 Türk atlısı sayesinde!] kolayca yendi, asinin askerleri ya öldürülmüş ya da kaçışa koyulmuş olduklarından ve Bryennios\'un kendisi yalnız kalmış bulunduğundan, onu yakaladı ve zavallıyı kör ederek onu kör haliyle Kentlerin Sultanına getirdi. İşte Bryennios ayaklanmasının sonu bu oldu...',
        source: 'İoannes Zonaras, Tarihlerin Özeti, Bilge Umar (çev.), Arkeoloji ve Sanat yay., İstanbul 2010, s.150-154',
        skills: ['Değişim ve Sürekliliği Algılama Becerisi', 'Zamanı Algılama ve Kronolojik Düşünme Becerisi'],
        questions: [
            { no: 9, text: 'Kanıt 5\'e göre Bizanslı komutanların, kendi içlerindeki isyancıları (Bryennios gibi) yenmek için kendi orduları yerine Süleymanşah\'ın 2000 kişilik Türk atlısına muhtaç kalması, Bizans\'ın Anadolu\'daki askeri ve siyasi gücünde nasıl bir değişimin yaşandığını anlatmaktadır?' }
        ]
    },
    // ---- SAYFA 6: KANIT 6 ----
    {
        type: 'evidence',
        num: 6,
        title: 'Kanıt 6: Fırsat',
        text: '"Bizans\'ın bu karışık durumdan faydalanan Süleymanşah, devletinin sınırlarını Marmara, Karadeniz ve Akdeniz yönlerinde genişleterek kısa zamanda, Bursa ve yörelerinden başka, Kocaeli Yarımadasını ele geçirerek Üsküdar ve Kadıköy\'e doğru ilerledi; hatta Anadolu kıyılarında gümrük daireleri kurup boğazdan gelip geçen gemilerden vergi almaya başladı. Süleymanşah\'ın Türkiye Selçuklu Devleti\'ni kurması ve başarılı fetihler yapması sonucunda, özellikle 1080 yılında, Azerbaycan\'dan kalabalık Türk kitleleri, Anadolu\'ya adeta akmaya başladı ve dolayısıyla bu ülkede, Türk nüfusu süratle çoğaldı."',
        source: 'Ali SEVİM, Anadolu\'nun Fethi Selçuklular Dönemi, TTK yay., Ankara 1987, s.82',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 10, text: 'Kanıt 6\'ya göre; Anadolu\'ya gelen Türklerin boğazlarda "gümrük idaresi" kurup deniz ticaretinden vergi almaya başlaması, onların ekonomik ve devlet teşkilatı anlayışında nasıl bir değişimi yansıtır?' },
            { no: 11, text: 'Kanıt 6\'ya göre 1080 yılından itibaren Azerbaycan\'dan gelen büyük Türk kitlelerinin Anadolu\'ya akmasıyla birlikte, Anadolu\'nun demografik yapısında nasıl bir değişim yaşanmıştır?' }
        ]
    },
    // ---- SAYFA 7: KANIT 8 ----
    {
        type: 'evidence',
        num: 8,
        title: 'Kanıt 8: Çaka Bey\'i Bizanslı Tarihçi Ioannes Zonaras Anlatıyor (1074-1130)',
        text: '...Ne var ki, başka bir noktadan yine imparatorluğun düşmanları kendilerini gösterdiler. Türkler sırf Anadolu\'yu işgal etmekle kalmıyorlardı, adaları da tehdit etmekte idiler. Önemsiz bir Türk olan, ama pek kurnaz Emir Çaka, az sayıda gemiyle Khios/Sakız adasının [doğu yani Anadolu\'ya bakan yanındaki, aynı adı taşıyan en büyük kentinin] limanına girdi ve onu savaşmadan [İzmir\'de (1081) olduğu gibi burada da yerli Rum halkın kendisine katılmasıyla] işgal edip, orada donanma inşa ettirmeye başladı. Bu donanma ile Lesbos/Midilli Adası, Samos/Sisam, Rodos\'u ve pek çok sayıda diğer adayı ele geçirdi.',
        source: 'İoannes Zonaras, Tarihlerin Özeti (Kitap XVII-XVIII), Bilge Umar (çev.), Arkeoloji ve Sanat yay., İstanbul 2010, s.165',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 15, text: 'Kanıt 8\'i incelediğinizde Türklerin, Çaka Bey ile birlikte tersane kurup gemilerle Ege adalarını fethetmeye başlaması, Türklerin askeri becerilerinde ve hedeflerinde nasıl bir değişimin yaşanmaya başlandığını göstermektedir?' }
        ]
    },
    // ---- SAYFA 8: KANIT 9 ----
    {
        type: 'evidence',
        num: 9,
        title: 'Kanıt 9: Bizans İmparatorunun Kılıç Arslan\'a Mektubu; Anna Kommena, Alexiad',
        text: 'Sultan\'ı mektuplarla ona (Çaka Bey\'e) karşı kışkırtmayı yararlı gördüğünden, bu kişiye şöyle [bir mektup] yazdı:\n\nŞanı büyük Sultan Kılıç Arslan! Biliyorsun ki Sultanlık sana baba mirası olarak geçmiştir. Oysa, senin kayın baban Çaka görünüşte Rum (Türkiye Selçukluları) devletine karşı silahlanıyor ve kendisine Basileus (Kral) dedirtiyor ama, besbelli ki bu bir aldatmacadır. Aslında, öylesine büyük deneyim sahibi bulunan ve son derecede bilgili bir kişi olan o, kendisinin Rumlar üzerinde Basileus\'luğa hiçbir hakkının bulunmadığını ve bu kadar büyük bir devletin başına geçmesinin olanaksız olduğunu biliyor. Kurduğu bütün tezgah sana karşı yönelmiştir. Bu durum karşısında sen ne onu başıboş bırakmalısın ne de cesaretini yitirmelisin; yapman gereken, erk\'inden yoksun bırakılmamak için uyanık durmaktır. Bana gelince, ben, Tanrının yardımıyla onu Rum ülkesinin sınırlarından kovarım; seni de kendi çıkarın için, ülkelerini ve egemenliğini uyanıklıkla korumaya ve olabilirse barışçı yollardan, o bunu istemezse silahla, onu yeniden kendi buyruğuna almaya davet ederim.',
        source: 'Anna Kommena, Alexiad, Bilge Umar (çev.), İnkılap Kitabevi, İstanbul 1996, s.126',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 16, text: 'Kanıt 9\'a göre Çaka Bey\'in denizlerde çok güçlenip kendine Basileus dedirtmeye başlaması, Türkiye Selçuklu Devleti ile Bizans arasında nasıl bir ilişkinin başlamasına neden olmuştur?' },
            { no: 17, text: 'Bizans\'ın eskiden Türkleri sadece savaş meydanlarında ordularla durdurmaya çalışırken, şimdi mektup yazarak bir Türk Sultanını diğer bir Türk Beyine karşı uyarması, Bizans\'ın savunma stratejilerinde nasıl bir değişime gittiğini gösterir?' }
        ]
    },
    // ---- SAYFA 9: KANIT 10 ----
    {
        type: 'evidence',
        num: 10,
        title: 'Kanıt 10: Görgü Tanığı: Guibert de Nogent (1055–1124) Bazı Haçlı Ordularını Anlatıyor',
        text: 'Haçlı ordusundaki fakir insanlardan bazıları beş parasız, yalınayak ve silahsız bir şekilde sefere katılmışlardı. Tamamen pislik içinde, çaresiz bir hayatları olduğu için diğer insanlar gibi rahat yaşama kavuşma hevesiyle herkesten önce ilerlemişlerdi. Norman kökenli Haçlılardan belli bir kısmı, hayat şartları bakımından bu tarz rezil insanlardan oluşmaktaydı. Bunlar kral ve lider tanımıyorlar, kendi başlarına oraya buraya serseri hareket ediyorlardı. Hatta ellerine verilen silahları ve zırhları da atmışlardı. Bunlar Tafur diye anılan birinin etrafında toplanarak, oraya buraya yıllarca saldırıp durdular.',
        source: 'İbrahim Ethem POLAT, Doğu ve Batı Kaynaklarında Haçlı Seferleri\'nde Yaşanan İnsanlık İhlalleri, Uluslararası Suçlar Ve Tarih Dergisi, Sayı 5, Ankara 2009',
        skills: ['Tarihsel Empati Becerisi', 'Tarihsel Sorun Analizi ve Karar Verme Becerisi'],
        questions: [
            { no: 18, text: 'Kanıt 10\'da anlatılan beş parasız, yalınayak ve çaresiz insanlardan biri olduğunuzu hayal edin. Hiçbir silahınız, askeri eğitiminiz ve sizi koruyacak bir lideriniz olmadığı halde, binlerce kilometre ötedeki Anadolu topraklarında siz ne yapardınız? Nasıl hayatta kalıp nasıl savaşırdınız?' }
        ]
    },
    // ---- SAYFA 10: KANIT 11 ----
    {
        type: 'evidence',
        num: 11,
        title: 'Kanıt 11: Bilinmeyen Birisi Anlatıyor',
        text: 'Frank orduları ilerleyip bir kampa varınca birçok yaya ve işçi, askerler daha gelmeden boğazı geçmeye gönderildi. Alexius, İznik ve civarındaki Türkleri, saldırıp onları öldürmeleri için uyardı. Öyle de oldu. İznik ve çevresindeki Türkler acele harekete geçip deniz kıyısında onlara saldırıp aman vermeden öldürdüler. Böylece ileri kampın tamamı yok edildi. Frank orduları Konstantinopolis\'e varınca Bizans İmparatoru ve soyluları ile karşılaştılar ve birbirlerine ant verdiler. Alexius onlarla birlikte başka bir yoldan Galatya üzerinden gitmeye hazırlandı. Bütün Franklar ve Bizanslılar doğrudan İznik önüne geldiler ve orasını Türkler\'den alıp imparatora verdiler. Oradan da Kilikya (Adana, Mersin ve civarı)\'ya yürüdüler. Toprak ayakları altında titredi. Suriye\'ye gelince, önce Antakya karşısında kamp kurmayı düşündüler. Orası bütün Suriye\'nin kapısıydı. Kentin yakınındaki bütün yerlere çadırlarını kurdular ve kente girip çıkmak isteyenlere bütün yolları kapattılar. Bütün bölgede öldürme ve yağmalama yaptılar.',
        source: 'Adı Bilinmeyen Bir Süryani, 1. ve 2. Haçlı Seferleri Vekayinamesi, Vedii İlmen (çev.) Yaba Yayınları, İstanbul 2005, s.10',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 19, text: 'Kanıt 11\'e göre Haçlı orduları ile Bizans İmparatoru\'nun birleşip ittifak kurması, Türkiye Selçuklu Devleti\'nin elinde bulunan İznik\'in kaderinde nasıl bir askeri ve siyasi sonuca yol açmıştır?' }
        ]
    },
    // ---- SAYFA 11: KANIT 12 ----
    {
        type: 'evidence',
        num: 12,
        title: 'Kanıt 12: 1. Haçlı Seferi, Bizanslı Tarihçi Ioannes Zonaras (1074-1130)',
        text: 'Ardından [Birinci Haçlı Seferi için] Franklar Kentlerin Sultanına yönelerek ve Anadolu\'yu bir uçtan ötekine geçmek amacıyla, Batı\'dan hareket ettiler. Hatta bu kitlesel hareketi, tanrısal alametin biri, önceden açıkladı: Batı\'dan hareket eden ve güneşi karartan buluta benzeyen büyük bir çekirge sürüsü, Kentlerin Sultanının üzerine düştü ve onu geride bırakarak, Anadolu\'ya indi. İşte böyle, Franklar [Anadolu\'dan] geçerken, Türklerin işgal etmekte olduğu, Bithynia\'daki [Rum/Anadolu Selçuklu Sultanlığı başkenti] Nikaia/İznik\'i kuşattılar ve büyük [uzun] bir zaman süresinden sonra ve her iki tarafın çok kayıplar vermesiyle, sonunda onu zapt ettiler. Bunun üzerine kenti pek çok para karşılığında, imparatora teslim ettiler ve kendileri daha içeriye doğru ilerlediler.',
        source: 'İoannes Zonaras, Tarihlerin Özeti (Kitap XVII-XVIII), Bilge Umar (çev.), Arkeoloji ve Sanat yay., İstanbul 2010, s.165',
        skills: ['Zamanı Algılama ve Kronolojik Düşünme Becerisi', 'Değişim ve Sürekliliği Algılama Becerisi'],
        questions: [
            { no: 20, text: 'Kanıt 12\'ye göre seferin başında Türklerin yönetimindeki İznik şehrinde, Frankların kuşatması ve İmparatorla yaptıkları anlaşma sonrasında nasıl bir siyasi değişim yaşanmıştır?' }
        ]
    },
    // ---- SAYFA 12: KANIT 13 ----
    {
        type: 'evidence',
        num: 13,
        title: 'Kanıt 13: Anna Kommena Dorileon (Eskişehir) Savaşını Anlatıyor',
        text: 'Buradan [savaş yeri olan Eskişehir Ovasından] başlayarak, taburlar, sıkı dizilerle ileri yürüyüşe yeniden koyuldular ve Ebra\'ike\'de [Eber Gölü yöresinde] Sultan Danişmend (Melik Gazi Gümüştigin) ve Hasan (ileri Türk Beylerinden birisi) ile karşılaştılar; yalnız Hasan\'ın komutası altında [bile] ağır donanımlı 80.000 yaya asker bulunmakta idi. Gerek iki ordunun da çok kalabalık sayıda bulunması yüzünden, gerek savaşan iki yandan hiçbiri ötekinin önünde kaçma durumuna düşmek istemediği için, çok azgın bir savaş verildi; Türkler, düşmanlarına göre daha gözü kara [korkusuz ve hırslı] savaştığından, sağ kanada komuta eden Bohemond, bunu görerek, [birlikleriyle] ordunun geri kalanından ayrıldı ve [dosdoğru] Sultan Kılıç Arslan\'ın kendisinin üzerine [onun bulunduğu, Türk ordusunun orta bölümüne] saldırdı; ozanın dediği üzere "Gücüne güvenen arslan gibi" idi. Bu [saldırı] Türkleri korkuttu ve Keltlere sırt dönmelerine [kaçmalarına] yol açtı.',
        source: 'Anna Kommena, Alexiad, Bilge Umar (çev.), İnkılap Kitabevi, İstanbul 1996, s.126',
        skills: ['Tarihsel Empati Becerisi', 'Tarihsel Sorun Analizi ve Karar Verme Becerisi'],
        questions: [
            { no: 21, text: 'Kanıt 13\'teki Bizans komutanı Bohemond\'un yerinde siz olsaydınız, onun gibi doğrudan Kılıç Arslan\'ın üstüne mi giderdiniz yoksa farklı bir taktik mi uygulardınız? Neden?' }
        ]
    },
    // ---- SAYFA 13: KANIT 14 ----
    {
        type: 'evidence',
        num: 14,
        title: 'Kanıt 14: Haçlı Seferi\'nin Bir Görgü Tanığı: Raimundus Aguilers, Antakya Olayları',
        text: '"...Antakya\'da her yerde çatışma başladı, zira düşmanlarımız (yani Türkler) iki taraflı saldırı planlamıştı. Tanrı ayırım yapmadı ve piyadelerin yanında savaştı, aynı anda şövalyelere de güldü... Biz savaşı kazanıp, ganimeti ele geçirince ölmüş olan Türklerin kafalarını kesip kampa götürdük ve onları sırıklara geçirdik. Türklerin kendilerine ve müttefiklerine iyi bir ders ve ihtar olsun diye. Bu Tanrı\'nın bir emri idi. Çünkü Türkler daha önce Kutsal Meryem\'in sancağını ele geçirip yere çakarak bizi küçük düşürmüşlerdi".',
        source: 'Birsel KÜÇÜKSİPAHİOĞLU, Birinci Haçlı Seferi\'nin Bir Görgü Tanığı: Raimundus Aguilers, Tarih Dergisi, Sayı 41, s.21',
        skills: ['Kanıta Dayalı Sorgulama ve Araştırma Becerisi'],
        questions: [
            { no: 22, text: 'Kanıt 14\'e göre Haçlılar Antakya\'yı aldıktan sonra yapmış oldukları eylemleri nasıl meşrulaştırmaktadır?' }
        ]
    },
    // ---- SAYFA 14: KANIT 15 ----
    {
        type: 'evidence',
        num: 15,
        title: 'Kanıt 15: Süryani Patrik Mihail Haçlı Seferlerinin Nedenleri Anlatıyor',
        text: 'Türkler, Suriye ve Filistin ülkelerine hâkim olduktan sonra, Kudüs\'e dua etmeye giden Hristiyanları dövmek, soymak, şehre ve mukaddes yerlere girmeyi haraca bağlamak gibi fenalıklar yapıyorlardı. Bundan başka, bir Hristiyan kervanı ve bilhassa Roma\'dan ve İtalya\'dan gelenleri görünce, onları imha etmeye gayret ediyorlardı. Birçok insanın bu suretle telef olmaları üzerine, kral ve kontlar, hiddetlenerek Roma\'dan yola çıktılar. Bütün memleketten birçok asker onlara katıldı ve onlar deniz yoluyla İstanbul\'a geldiler.',
        source: 'Hrant D. ANDREASYAN, Süryani Patrik Mihail\'in Vakainamesi, 2. Kısım (1042-1195) TTK Basılmamış Tercüme Eserler, Ankara 1944',
        skills: ['Kanıta Dayalı Sorgulama ve Araştırma Becerisi', 'Tarihsel Sorun Analizi ve Karar Verme Becerisi'],
        questions: [
            { no: 23, text: 'Kanıt 15\'te Patrik Mihail haçlı seferinin sebebini nasıl açıklamaktadır?' },
            { no: 24, text: 'Kanıt 15\'teki Haçlı seferinin nedenleriyle, bizim kaynaklarımızda geçen nedenleri karşılaştırdığınızda neler söyleyebilirsiniz? (farklılıklar/benzerlikler)' }
        ]
    },
    // ---- SAYFA 15: ANA ETKİNLİK ----
    {
        type: 'activity'
    },
    // ---- SAYFA 16: SONUÇ ----
    {
        type: 'conclusion'
    }
];

// ===== CEVAP DEPOLAMA =====
const savedAnswers = {};

function saveAnswer(key, value) {
    savedAnswers[key] = value;
}

function getAnswer(key) {
    return savedAnswers[key] || '';
}

// ===== SAYFA RENDER FONKSİYONLARI =====

function renderIntro() {
    return '<div class="kitap-page kitap-intro">' +
        '<span class="intro-icon">📜</span>' +
        '<h2 class="intro-main-title">Yerleşme ve Devletleşme Sürecinde<br>Selçuklu Türkiyesi</h2>' +

        '<div class="kazanim-box">' +
            '<h3>🎯 Kazanımlar</h3>' +
            '<ul>' +
                '<li>Anadolu\'daki ilk Türk siyasi teşekküllerinin birbirleriyle ve çevre devletlerle olan ilişkilerini uzlaşma ve çatışma bağlamında değerlendirir.</li>' +
                '<li>Haçlı Seferini Türklerle ilk temas bağlamında açıklar.</li>' +
            '</ul>' +
        '</div>' +

        '<div class="beceri-box">' +
            '<h3>🧠 Beceriler</h3>' +
            '<div class="beceri-tags">' +
                skillTag('Tarihsel Empati Becerisi') +
                skillTag('Zamanı Algılama ve Kronolojik Düşünme Becerisi') +
                skillTag('Değişim ve Sürekliliği Algılama Becerisi') +
            '</div>' +
        '</div>' +

        '<div class="giris-text">' +
            '<h3>📖 Giriş</h3>' +
            '<p>1071 yılını düşünün… Anadolu\'da dengeler değişiyor. Malazgirt Meydan Muharebesi\'nden sonra Türkler Anadolu\'ya yerleşmeye başlıyor. Yeni şehirler ele geçiriliyor, beylikler kuruluyor, ittifaklar yapılıyor, savaşlar yaşanıyor. Peki bu süreç herkes için aynı anlamı mı taşıyordu?</p>' +
            '<p class="highlight-q">Bir Bizanslı tarihçi bu dönemi nasıl anlatıyordu?</p>' +
            '<p class="highlight-q">Bir Ermeni ya da Süryani yazar neler hissediyordu?</p>' +
            '<p class="highlight-q">Selçuklu kaynakları bu gelişmeleri nasıl yorumluyordu?</p>' +
            '<p class="highlight-q">Aynı olay farklı insanlar için "fetih", "istila", "kurtuluş" ya da "felaket" olabilir mi?</p>' +
            '<p>Bu etkinlikte sizler, 11. yüzyıl Anadolu\'suna ait farklı kaynakları inceleyeceksiniz. Kutalmışoğlu Süleymanşah dönemindeki gelişmeleri, Bizans ile ilişkileri ve ardından gelen Birinci Haçlı Seferi sürecini dönemin tanıklarının gözünden okuyacaksınız.</p>' +
            '<p>Amacınız yalnızca "ne oldu?" sorusuna cevap vermek değil.</p>' +
            '<ul class="giris-questions">' +
                '<li>Olaylar hangi sırayla gerçekleşti?</li>' +
                '<li>Taraflar birbirlerini nasıl görüyorlardı?</li>' +
                '<li>Aynı olay neden farklı kaynaklarda farklı anlatılıyor?</li>' +
                '<li>Bu süreçte Anadolu\'da neler değişti, neler aynı kaldı?</li>' +
            '</ul>' +
            '<p>Bu soruların cevaplarını kanıtlara dayanarak bulmaya çalışacaksınız.</p>' +
        '</div>' +

        '<div class="giris-note">' +
            '💡 <strong>Unutmayın:</strong> Tarih, tek bir ses değildir. Bu etkinlikte siz, farklı sesleri dinleyerek kendi tarihsel yorumunuzu oluşturacaksınız.' +
        '</div>' +
    '</div>';
}

function renderEvidence(page, pageIndex) {
    let html = '<div class="kitap-page kitap-kanit-page">';

    // Dinle butonu - animasyonlu ve çekici
    html += '<button class="kitap-dinle-btn" onclick="window.EtkinlikKitap.dinle()">' +
        '<span class="dinle-icon">🔊</span> Dinle</button>';

    // Başlık
    html += '<h2 class="kitap-kanit-title">' + page.title + '</h2>';

    // Kanıt metni
    html += '<div class="kitap-kanit-metin">' +
        '<p>' + page.text.replace(/\n/g, '<br>') + '</p>' +
    '</div>';

    // Kaynak
    html += '<div class="kitap-kanit-kaynak">' + page.source + '</div>';

    // Beceriler
    html += '<div class="kitap-beceriler">' +
        '<h4>Kazandırılan Beceriler</h4>' +
        '<div class="beceri-tags">' +
        page.skills.map(function(s) { return skillTag(s); }).join('') +
        '</div></div>';

    // Sorular
    html += '<div class="kitap-sorular">' +
        '<h4>✏️ Sıra Sizde</h4>';

    page.questions.forEach(function(q) {
        var ansKey = 'q_' + q.no;
        var savedVal = getAnswer(ansKey);
        html += '<div class="kitap-soru-item">' +
            '<div class="kitap-soru-text"><strong>' + q.no + '.</strong> ' + q.text + '</div>' +
            '<textarea class="kitap-cevap-area" placeholder="Cevabınızı buraya yazın..." ' +
            'data-question="' + ansKey + '" ' +
            'oninput="window.EtkinlikKitap.saveAns(this)">' + savedVal + '</textarea>' +
        '</div>';
    });

    html += '</div></div>';
    return html;
}

function renderActivity() {
    var savedVal = getAnswer('ana_etkinlik');
    return '<div class="kitap-page kitap-etkinlik-page">' +
        '<span class="etkinlik-icon">🏛️</span>' +
        '<h2>Ana Etkinlik</h2>' +
        '<p class="etkinlik-desc">Bu bölümde tüm kanıtları göz önünde bulundurarak, Anadolu\'nun Türkleşme sürecini farklı kaynakların perspektifinden değerlendirin. ' +
        'Selçuklu beylerinin yerleşme stratejileri, Bizans\'ın iç karışıklıkları, farklı halkların gözünden yaşanan değişimler ve Haçlı Seferleri\'nin etkilerini bir bütün olarak ele alın.</p>' +
        '<p class="etkinlik-desc"><strong>Şu soruyu cevaplayın:</strong> Aynı tarihsel olaylar neden farklı kaynaklarda farklı şekillerde anlatılmaktadır? ' +
        'Bu farklılıklar tarih biliminde "tarafsızlık" kavramı hakkında bize ne söylemektedir? Düşüncelerinizi kanıtlardan örnekler vererek yazınız.</p>' +
        '<textarea class="kitap-etkinlik-area" placeholder="Düşüncelerinizi ve değerlendirmenizi buraya yazın..." ' +
        'data-question="ana_etkinlik" oninput="window.EtkinlikKitap.saveAns(this)">' + savedVal + '</textarea>' +
    '</div>';
}

function renderConclusion() {
    return '<div class="kitap-page kitap-sonuc-page">' +
        '<span class="sonuc-icon">🏆</span>' +
        '<h2>Etkinlik Tamamlandı</h2>' +
        '<p>Tebrikler! Bu etkinlikte 11. yüzyıl Anadolu\'sına ait farklı kaynakları inceleyerek, tarihsel olayları çok yönlü bir perspektiften değerlendirdiniz.</p>' +
        '<p>Selçuklu kaynaklarından Bizanslı tarihçilere, Ermeni yazarlardan Süryani vekayinamecilere kadar pek çok farklı sesin tanıklığını okudunuz. ' +
        'Her kaynağın kendi bakış açısını, önyargılarını ve duygularını nasıl yansıttığını gördünüz.</p>' +
        '<p>Artık biliyorsunuz ki <strong>tarih, tek bir ses değildir</strong>. Gerçek tarihsel anlayış, farklı sesleri dinleyerek ve kanıtlara dayanarak kendi yorumunuzu oluşturmakla mümkündür.</p>' +
        '<p style="color: var(--accent-gold); margin-top: 25px; font-style: italic;">"Tarih yazmak, tarih yapmak kadar mühimdir. Yazan yapana sadık kalmazsa, değişmeyen hakikat, insanlığı şaşırtacak bir mahiyet alır." — Mustafa Kemal Atatürk</p>' +
    '</div>';
}

function renderCurrentPage(direction) {
    var idx = window.EtkinlikKitap.currentPage;
    var page = PAGES[idx];
    var html = '';

    if (page.type === 'intro') {
        html = renderIntro();
    } else if (page.type === 'evidence') {
        html = renderEvidence(page, idx);
    } else if (page.type === 'activity') {
        html = renderActivity();
    } else if (page.type === 'conclusion') {
        html = renderConclusion();
    }

    // Animasyon Sınıfları Eklentisi (Sayfa çevirme efekti)
    var animClass = direction === 'prev' ? 'page-turn-prev' : 'page-turn-next';
    var animatedHtml = '<div class="kitap-page-frame ' + animClass + '">' + html + '</div>';

    var area = document.getElementById('kitap-content-area');
    if (area) {
        // Eski frame'i al ve çıkış animasyonu ver
        var oldFrame = area.querySelector('.kitap-page-frame');
        if (oldFrame) {
            oldFrame.classList.add('page-exit');
            setTimeout(() => {
                area.innerHTML = animatedHtml;
                area.scrollTop = 0;
                // Otomatik ses oynatmayı başlat
                if (window.EtkinlikKitap && window.EtkinlikKitap.autoPlayAudio) {
                    window.EtkinlikKitap.autoPlayAudio();
                }
            }, 300); // Eski sayfanın kaybolma süresi
        } else {
            area.innerHTML = animatedHtml;
            area.scrollTop = 0;
            // Otomatik ses oynatmayı başlat
            if (window.EtkinlikKitap && window.EtkinlikKitap.autoPlayAudio) {
                window.EtkinlikKitap.autoPlayAudio();
            }
        }
    }

    // Sayfa göstergesini güncelle
    var cur = document.getElementById('kitap-current-page');
    if (cur) cur.textContent = idx + 1;

    // Butonları güncelle (Timeout ile DOM'un hazır olmasını bekle)
    setTimeout(() => {
        var prevBtn = document.getElementById('kitap-prev-btn');
        var nextBtn = document.getElementById('kitap-next-btn');
        if (prevBtn) prevBtn.disabled = (idx === 0);
        if (nextBtn) nextBtn.disabled = (idx === PAGES.length - 1);
    }, 50);
}

// ===== EKRAN FABRİKASI =====
export const EtkinlikKitapScreen = () => {
    // İlk render için zamanlayıcı (DOM Render Garantisi)
    setTimeout(function() {
        if (window.EtkinlikKitap) {
            if (window.audio && window.audio.backgroundMusic) {
                window.audio.backgroundMusic.pause();
            }
            window.EtkinlikKitap.currentPage = 0;
            // İlk açılışta direk renderla (animasyon beklemeden)
            var area = document.getElementById('kitap-content-area');
            if (area) {
                var html = renderIntro();
                area.innerHTML = '<div class="kitap-page-frame">' + html + '</div>';
                area.scrollTop = 0;
            }
            
            // UI Güncellemeleri
            var cur = document.getElementById('kitap-current-page');
            if (cur) cur.textContent = window.EtkinlikKitap.currentPage + 1;
            
            var prevBtn = document.getElementById('kitap-prev-btn');
            var nextBtn = document.getElementById('kitap-next-btn');
            if (prevBtn) prevBtn.disabled = true;
            if (nextBtn) nextBtn.disabled = false;
            // Swipe Gezintisini Başlat - Mouse ve Touch desteği
            if (window.EtkinlikKitap && window.EtkinlikKitap.initSwipe) {
                window.EtkinlikKitap.initSwipe();
            }
        }
    }, 150);

    return '<div id="etkinlik-kitap-screen" class="screen">' +
        // Header
        '<div class="kitap-header">' +
            '<button class="kitap-back-btn" onclick="window.Router.showScreen(\'kanit-temelli-screen\')">⬅️ GERİ</button>' +
            '<span class="kitap-header-title">Selçuklu Türkiyesi</span>' +
            '<div class="kitap-page-indicator">' +
                '<span class="current-pg" id="kitap-current-page">1</span> / ' + PAGES.length +
            '</div>' +
        '</div>' +
        // İçerik Alanı
        '<div class="kitap-content-area" id="kitap-content-area"></div>' +
        // Footer (Navigasyon Alanı)
        '<div class="kitap-footer">' +
            '<button class="kitap-nav-btn prev-btn" id="kitap-prev-btn" onclick="window.EtkinlikKitap.prevPage()" disabled>◀ Önceki</button>' +
            '<div class="kitap-nav-center">' + PAGES.length + ' Sayfa</div>' +
            '<button class="kitap-nav-btn next-btn" id="kitap-next-btn" onclick="window.EtkinlikKitap.nextPage()">Sonraki ▶</button>' +
        '</div>' +
    '</div>';
};

// ===== KİTAP KONTROLCÜSÜ =====
window.EtkinlikKitap = {
    currentPage: 0,
    _origPlaySound: null,
    currentAudio: null,

    stopAudio: function() {
        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio.currentTime = 0;
            this.currentAudio = null;
        }
    },

    nextPage: function() {
        if (this.currentPage < PAGES.length - 1) {
            this.stopAudio();
            this.currentPage++;
            renderCurrentPage('next');
        }
    },

    prevPage: function() {
        if (this.currentPage > 0) {
            this.stopAudio();
            this.currentPage--;
            renderCurrentPage('prev');
        }
    },

    goToPage: function(n) {
        if (n >= 0 && n < PAGES.length) {
            this.stopAudio();
            var dir = n > this.currentPage ? 'next' : 'prev';
            this.currentPage = n;
            renderCurrentPage(dir);
        }
    },

    saveAns: function(el) {
        if (el && el.dataset && el.dataset.question) {
            saveAnswer(el.dataset.question, el.value);
        }
    },

    autoPlayAudio: function() {
        var page = PAGES[this.currentPage];
        if (page && page.type === 'evidence' && page.num) {
            // Küçük bir gecikme ile başlat (DOM render ve geçiş animasyonu için)
            setTimeout(() => {
                this.startPlayback(page.num);
            }, 500);
        }
    },

    startPlayback: function(num) {
        // Varsa eskiyi durdur
        this.stopAudio();
        
        var audioUrl = '/assets/audio/evidence/kanit-' + num + '.mp3';
        this.currentAudio = new Audio(audioUrl);
        
        // Genel mute ayarını ezerek %100 sesle başlatıyoruz
        this.currentAudio.muted = false;
        this.currentAudio.volume = 1.0;
        
        var self = this;
        this.currentAudio.play().then(() => {
            this.updateDinleBtn(true);
        }).catch(function(e) {
            console.error("Ses oynatılamadı:", e);
        });
        
        this.currentAudio.onended = function() {
            self.currentAudio = null;
            self.updateDinleBtn(false);
        };
    },

    updateDinleBtn: function(isPlaying) {
        var btn = document.querySelector('.kitap-dinle-btn');
        if (btn) {
            btn.innerHTML = isPlaying ? 
                '<span class="dinle-icon">⏸️</span> Durdur' : 
                '<span class="dinle-icon">🔊</span> Dinle';
        }
    },

    dinle: function() {
        var page = PAGES[this.currentPage];
        if (!page || page.type !== 'evidence' || !page.num) {
            if (window.utils && window.utils.showToast) {
                window.utils.showToast('🎧 Bu sayfada sesli anlatım bulunmuyor.', 'warning');
            }
            return;
        }

        // Eğer ses zaten çalıyorsa durdur (Pause/Stop görevi)
        if (this.currentAudio && !this.currentAudio.paused) {
            this.currentAudio.pause();
            this.updateDinleBtn(false);
            return;
        }
        
        // Eğer ses duraklatılmışsa devam et veya yeniden başlat
        if (this.currentAudio && this.currentAudio.paused) {
            this.currentAudio.play().then(() => {
                this.updateDinleBtn(true);
            }).catch(e => console.error(e));
            return;
        }

        // Ses objesi yoksa baştan yarat ve çal
        this.startPlayback(page.num);
    },

    // Kitaptan çıkış: müzik ve sesleri geri aç
    exitBook: function() {
        this.stopAudio();
        
        // Kanıt Temelli ekranına dön
        window.Router.showScreen('kanit-temelli-screen');
    },

    // ===== SWIPE (KAYDIRMA) SİSTEMİ =====
    initSwipe: function() {
        var area = document.getElementById('kitap-content-area');
        if (!area) return;

        var startX = 0;
        var threshold = 50; // Kaydırma hassasiyeti (pixel) - Mobilde daha düşük
        var isMobile = window.innerWidth < 768;
        var edgeMargin = isMobile ? 50 : 80; // Mobilde daha geniş alan ama daha erişilebilir
        var isDragging = false;
        var startSide = null; // 'left' | 'right'

        var onStart = (e) => {
            // Textarea veya input üzerine tıklandığında kaydırmayı engelle
            if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') return;
            
            var x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            var w = window.innerWidth;

            // Sadece kenarlardan başlatıldığında aktif olsun
            if (x < edgeMargin) {
                startSide = 'left';
            } else if (x > w - edgeMargin) {
                startSide = 'right';
            } else {
                startSide = null;
                return;
            }

            startX = x;
            isDragging = true;
        };

        var onEnd = (e) => {
            if (!isDragging || !startSide) return;
            
            var endX = e.type.includes('touch') ? e.changedTouches[0].clientX : e.clientX;
            var diffX = endX - startX;

            if (Math.abs(diffX) > threshold) {
                if (diffX > 0 && startSide === 'left') {
                    // Soldan sağa çekme -> Önceki Sayfa
                    this.prevPage();
                } else if (diffX < 0 && startSide === 'right') {
                    // Sağdan sola çekme -> Sonraki Sayfa
                    this.nextPage();
                }
            }
            isDragging = false;
            startSide = null;
        };

        // Mouse Eventleri
        area.addEventListener('mousedown', onStart);
        window.addEventListener('mouseup', onEnd); // Window üzerinde yakala ki dışarı bırakınca da çalışsın

        // Touch Eventleri
        area.addEventListener('touchstart', onStart, { passive: true });
        area.addEventListener('touchend', onEnd, { passive: true });
    }
};
